export class ApiUrl {
  // ********************* Dashboard  ************/
  public static storeRadius: string = 'admin/update/radius';
  public static setting: string = 'admin/create/settings';
  public static getSetting: string = 'admin/setting/data';

  // ********************* Admin  ************/
  public static adminRegister: string = 'admin/register';
  public static adminEdit: string = 'admin/update';
  public static adminDelete: string = 'admin/delete';
  public static adminLogin: string = 'admin/login';
  public static adminList: string = 'admin/list';
  public static changepassword: string = 'admin/change/password/';
  public static twoFaSetup: string    = 'admin/2fa/setup';
  public static twoFaVerify: string   = 'admin/2fa/verify-setup';
  public static twoFaStatus: string   = 'admin/2fa/status';
  public static twoFaDisable: string  = 'admin/2fa/disable';

  //******************Store  *************/
  public static addStore: string = 'admin/store/register';
  public static storeById: string = 'admin/store/';

  public static storeList: string = 'admin/store/list';
  public static storeListById: string = 'admin/manager/allstores/data/';
  public static storeListByManagerId: string = 'admin/manager/stores/data';
  public static storeUpdateById: string = 'admin/store/update';
  public static deleteStore: string = 'admin/store/delete';
  public static copyStore: string = 'admin/store/';
  public static copyJobStatus: string = 'admin/store/copy-job/'; // GET {copyJobStatus}{jobId}
  public static storeData: string = 'admin/visits/count';

  public static storeListAdminDropdown: string = 'admin/store/list/dropdown';
  public static storeListManagerDropdown: string =
    'admin/store/list/manager/dropdown/';

  public static storeDoorStatus: string = 'admin/doorstatus/list';
  public static storeDoorStatusById: string = 'admin/manager/doorstatus/list/';
  public static storeOpening: string = 'admin/storedoor/opening/';
  public static storeDoorGraph: string = 'admin/graph/doorstatus/data';
  public static managerStoreDoorGraph: string = 'admin/graph/doorstatus/data/';
  public static getStoreListForNotification: string =
    'admin/notification/store/list';

  //******************API Key Management*************/
  public static getAllApiKeys: string = 'api-keys';
  public static getStoreApiKey: string = 'api-keys/';
  public static generateApiKey: string = 'api-keys';
  public static deactivateApiKey: string = 'api-keys/';

  //******************Card UID Management*************/
  public static getRecentCardUIDs: string = 'card-uid/';
  public static linkCardToUser: string = 'user-cards/link';
  public static getUserCards: string = 'user-cards/';
  public static getCardUserInfo: string = 'user-cards/card/';

  //*******************User **********/
  public static getUserList: string = 'admin/users/list';
  public static addUser: string = 'admin/create/user';
  public static updateUser: string = 'admin/update/user/';
  public static editUser: string = 'admin/user/listing';
  public static getUserById: string = 'admin/user/listing/';
  public static deleteUser: string = 'admin/delete/user/';
  public static updatepassword: string = 'admin/update/password/';
  public static getUserVisit: string = 'admin/store/visits/data';
  public static getUserVisitById: string = 'admin/store/visits/data/';
  public static getUserListForNotification: string =
    'admin/notification/user/list';
  public static forcelogoutUser: string = 'admin/force/logout';
  public static createStoreVisit: string = 'admin/store/visit/create';

  //*******************Terms and Conditions **********/
  public static addTermsAndConditions: string =
    'admin/create/termsandconditions';
  public static getTermsAndConditions: string = 'admin/termsandconditions';

  //*******************Info Page (Signup) **********/
  public static getInfoPage: string = 'admin/infopage/';        // + language
  public static createInfoPage: string = 'admin/infopage/create';

  //*******************QR Landing Page **********/
  public static getQrLanding: string = 'admin/qr-landing/';        // + language
  public static createQrLanding: string = 'admin/qr-landing/create';

  //********************upload onboarding image*************************/
  public static uploadimage: string = 'admin/onboarding/create';
  public static updateuploadimage: string = 'admin/onboarding/update/';
  public static getimages: string = 'admin/onboarding';

  //********************Push notification*************************/
  public static sendNotification: string = 'admin/push/notification';

  //******************** Store opening *************************/
  public static addTimings: string = 'admin/timings/create';
  public static getTimings: string = 'admin/timings/list/';
  public static updateTimings: string = 'admin/timings/edit/';

  //******************** Holidays *************************/
  public static addHolidays: string = 'admin/nationalholidays/create';
  public static getHolidays: string = 'admin/nationalholidays/list';
  public static getHolidayById: string = 'admin/nationalholidays/list/';
  public static updateHoliday: string = 'admin/nationalholidays/update/';
  public static deleteHoliday: string = 'admin/nationalholidays/delete/';
  public static deleteHolidayTimings: string = 'admin/holiday/timing/delete/';

  //******************** Ecommerce *************************/
  // Product Management
  public static getStoreProducts: string = 'products/store/';
  public static exportStoreProducts: string = 'products/store/';
  public static getProductDetails: string = 'products/store/';
  public static createProduct: string = 'products/store/';
  public static updateProduct: string = 'products/store/';
  public static deleteProduct: string = 'products/store/';
  public static checkProductAvailability: string = 'products/store/';
  public static productFeatureFlags: string = 'products/feature-flags';
  public static getProductDetailsById = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}`;
  public static setProductPlacement = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}/placement`;
  public static getProductPlacementHistory = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}/placement/history`;
  public static createProductPriceSchedule = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}/price-schedule`;
  public static updateProductPriceSchedule = (storeId: string, productId: string, scheduleId: string) =>
    `products/store/${storeId}/product/${productId}/price-schedule/${scheduleId}`;
  public static deleteProductPriceSchedule = (storeId: string, productId: string, scheduleId: string) =>
    `products/store/${storeId}/product/${productId}/price-schedule/${scheduleId}`;
  public static getProductPriceScheduleHistory = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}/price-schedule`;
  public static createProductMultiBuyOffer = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}/multi-buy-offer`;
  public static updateProductMultiBuyOffer = (storeId: string, productId: string, offerId: string) =>
    `products/store/${storeId}/product/${productId}/multi-buy-offer/${offerId}`;
  public static deleteProductMultiBuyOffer = (storeId: string, productId: string, offerId: string) =>
    `products/store/${storeId}/product/${productId}/multi-buy-offer/${offerId}`;
  public static getProductMultiBuyOffers = (storeId: string, productId: string) =>
    `products/store/${storeId}/product/${productId}/multi-buy-offer`;

  // Discount group multi-buy offers (store-scoped)
  public static discountGroupOffersForStore = (storeId: string) =>
    `discount-group-offers/store/${storeId}`;
  public static discountGroupOffersGroups = (storeId: string) =>
    `discount-group-offers/store/${storeId}/groups`;
  public static discountGroupOffersGroupProducts = (storeId: string, discountGroup: string) =>
    `discount-group-offers/store/${storeId}/groups/${encodeURIComponent(discountGroup)}/products`;
  public static discountGroupOfferById = (storeId: string, offerId: string) =>
    `discount-group-offers/store/${storeId}/${offerId}`;

  // Category Management
  public static getStoreCategories: string = 'products/store/';
  public static createCategory: string = 'products/store/';
  public static updateCategory: string = 'products/store/';
  public static deleteCategory: string = 'products/store/';

  // Order Management - continued
  public static processRefund: string = 'orders/store/';

  // Analytics & Financial (Store APIs - Actually Available)
  public static getStoreDashboard: string = 'store/';
  public static getHistoricalCharts: string = 'store/';
  public static getSalesAnalytics: string = 'store/';
  public static getInventoryAnalytics: string = 'store/';
  public static getStoreCategoryReport: string = 'store/';
  public static exportStoreCategoryReport: string = 'store/';
  public static exportStoreTransactions: string = 'store/';
  public static getPaymentHistory: string = 'payments/store/';
  public static requestPayout: string = 'payouts/store/';

  // Inventory Management
  public static getInventorySummary: string = 'inventory/store/';
  public static getLowStockProducts: string = 'inventory/store/';
  public static updateProductStock: string = 'inventory/store/';

  // Order Management
  public static getStoreOrders: string = 'orders/store/';
  public static getOrderDetails: string = 'orders/';
  public static updateOrderStatus: string = 'orders/';
  public static processPayment: string = 'orders/';

  // Historical Chart Data
  public static getHistoricalChartData: string = 'store/';

  // Low Stock & Bulk Operations
  public static getLowStockAlerts: string = 'store/';
  public static bulkUpdateInventory: string = 'store/';

  // Financial Management (Store APIs)
  public static getCurrentBalance: string = 'store/';
  public static getBalanceHistory: string = 'store/';
  public static getStoreTransactions: string = 'store/';

  // Store Configuration
  public static getStoreConfig: string = 'store/';
  public static updateStoreConfig: string = 'store/';

  // Additional Order Management APIs
  public static exportOrders: string = 'orders/store/';
  public static getOrderStatistics: string = 'orders/store/';
  public static searchOrders: string = 'orders/store/';
  public static bulkUpdateOrders: string = 'orders/store/';

  // Store Settings Management
  public static getStoreSettings: string = 'store/';
  public static updateStoreSettings: string = 'store/';
  public static testTomraConnection: string = 'store/';

  // Cart Management APIs
  public static getStoreCarts: string = 'cart/store/';
  public static getAbandonedCarts: string = 'cart/store/';
  public static getCartAnalytics: string = 'cart/store/';

  // Basket Audit Trail
  public static getBasketAuditEvents: string = 'orders/store/';
  public static getScanInsights = (storeId: string) => `admin/stores/${storeId}/scan-insights`;

  // Mobile Client Diagnostics (global, not store-scoped)
  public static mobileClientDiagnostics: string = 'admin/mobile-client-diagnostics';
  public static mobileClientDiagnosticById = (id: string) => `admin/mobile-client-diagnostics/${id}`;
  public static mobileClientDiagnosticSession = (diagnosticSessionId: string) =>
    `admin/mobile-client-diagnostics/session/${diagnosticSessionId}`;
  public static mobileClientDiagnosticsAdoption: string = 'admin/mobile-client-diagnostics/adoption';

  // Terminal Payment Logs
  public static getTerminalLogs = (storeId: string) => `store/${storeId}/admin/terminal-logs`;
  public static getTerminalLogDetail = (storeId: string, id: string) => `store/${storeId}/admin/terminal-logs/${id}`;
  public static reconcileTerminalLog = (logId: string) => `pos/terminal-log/${logId}/reconcile`;

  // POS Client Diagnostics
  public static getClientDiagnostics = (storeId: string) => `store/${storeId}/admin/client-diagnostics`;
  public static getClientDiagnosticDetail = (storeId: string, id: string) => `store/${storeId}/admin/client-diagnostics/${id}`;
  public static getClientDiagnosticSession = (storeId: string, sessionId: string) =>
    `store/${storeId}/admin/client-diagnostics/session/${sessionId}`;
  public static getTerminalHealth = (storeId: string) => `store/${storeId}/admin/terminal-health`;
  public static getOnlineTablets: string = 'pos/remote/online-tablets';

  // POS Webapp managed updates (releases + fleet matrix)
  public static getWebappReleases: string = 'admin/webapp-releases';
  public static postWebappRelease: string = 'admin/webapp-releases';
  public static patchWebappRelease = (id: string) => `admin/webapp-releases/${id}`;
  public static getWebappUpdateStatus: string = 'admin/webapp-update-status';
  public static postWebappUpdateAssign: string = 'admin/webapp-update/assign';
  public static postWebappUpdatePush: string = 'admin/webapp-update/push';

  // POS Terminals (store-scoped)
  public static getPosTerminals = (storeId: string) => `admin/stores/${storeId}/pos-terminals`;
  public static createPosTerminal = (storeId: string) => `admin/stores/${storeId}/pos-terminals`;
  public static updatePosTerminal = (storeId: string, terminalId: string) =>
    `admin/stores/${storeId}/pos-terminals/${terminalId}`;
  public static deletePosTerminal = (storeId: string, terminalId: string) =>
    `admin/stores/${storeId}/pos-terminals/${terminalId}`;
  public static getPosTerminalUsers = (storeId: string) => `admin/stores/${storeId}/pos-terminal-users`;

  // Chains
  public static CHAINS: string = 'chains';
  public static CHAIN_BY_ID = (id: string) => `chains/${id}`;
  public static CHAIN_STORES = (chainId: string) => `chains/${chainId}/stores`;
  public static CHAIN_STORES_ADD = (chainId: string, storeId: string) => `chains/${chainId}/stores/${storeId}`;
  public static CHAIN_MANAGERS = (chainId: string) => `chains/${chainId}/managers`;
  public static CHAIN_MANAGER_BY_ID = (chainId: string, managerId: string) => `chains/${chainId}/managers/${managerId}`;
  public static CHAIN_REPORTS = (chainId: string) => `chains/${chainId}/reports`;
  public static CHAIN_REPORTS_EXPORT = (chainId: string) => `chains/${chainId}/reports/export`;
  public static CHAIN_CATEGORY_REPORTS = (chainId: string) => `chains/${chainId}/reports/categories`;
  public static CHAIN_CATEGORY_REPORTS_EXPORT = (chainId: string) => `chains/${chainId}/reports/categories/export`;
  public static MY_CHAINS: string = 'chains/my';
  public static CHAIN_BRANDING = (chainId: string) => `chains/${chainId}/branding`;
  public static CHAIN_UPLOAD = (chainId: string) => `chains/${chainId}/upload`;

  // Chain Catalog — Categories
  public static CHAIN_CATEGORIES = (chainId: string) => `categories/chain/${chainId}`;
  public static CHAIN_CATEGORY_BY_ID = (chainId: string, categoryId: string) => `categories/chain/${chainId}/${categoryId}`;

  // Chain Catalog — Products
  public static CHAIN_PRODUCTS = (chainId: string) => `products/chain/${chainId}`;
  public static CHAIN_PRODUCT_BY_ID = (chainId: string, productId: string) => `products/chain/${chainId}/${productId}`;

  // ******************** Loyalty Discount *************************/
  public static getLoyaltyConfig = (storeId: string) => `loyalty/config/${storeId}`;
  public static updateLoyaltyConfig = (storeId: string) => `loyalty/config/${storeId}`;
  public static getLoyaltyMembers = (storeId: string) => `loyalty/members/${storeId}`;
  public static addLoyaltyMember = (storeId: string) => `loyalty/members/${storeId}`;
  public static updateLoyaltyMember = (storeId: string, membershipId: string) => `loyalty/members/${storeId}/${membershipId}`;
  public static deleteLoyaltyMember = (storeId: string, membershipId: string) => `loyalty/members/${storeId}/${membershipId}`;
  public static getLoyaltyAnalytics = (storeId: string) => `loyalty/analytics/${storeId}`;
  public static getLoyaltyVouchers = (storeId: string) => `loyalty/vouchers/${storeId}`;
  public static createLoyaltyVoucher = (storeId: string) => `loyalty/vouchers/${storeId}`;
  public static updateLoyaltyVoucher = (storeId: string, voucherId: string) => `loyalty/vouchers/${storeId}/${voucherId}`;
  public static deleteLoyaltyVoucher = (storeId: string, voucherId: string) => `loyalty/vouchers/${storeId}/${voucherId}`;
  public static getUserSearch: string = 'admin/users/list';

  // Chain Loyalty
  public static getChainLoyaltyConfig = (chainId: string) => `loyalty/chain-config/${chainId}`;
  public static updateChainLoyaltyConfig = (chainId: string) => `loyalty/chain-config/${chainId}`;
  public static getChainLoyaltyMembers = (chainId: string) => `loyalty/chain-members/${chainId}`;
  public static addChainLoyaltyMember = (chainId: string) => `loyalty/chain-members/${chainId}`;
  public static updateChainLoyaltyMember = (chainId: string, membershipId: string) => `loyalty/chain-members/${chainId}/${membershipId}`;
  public static deleteChainLoyaltyMember = (chainId: string, membershipId: string) => `loyalty/chain-members/${chainId}/${membershipId}`;

  // Chain Loyalty Vouchers
  public static getChainLoyaltyVouchers = (chainId: string) => `loyalty/chain-vouchers/${chainId}`;
  public static createChainLoyaltyVoucher = (chainId: string) => `loyalty/chain-vouchers/${chainId}`;
  public static updateChainLoyaltyVoucher = (chainId: string, voucherId: string) => `loyalty/chain-vouchers/${chainId}/${voucherId}`;
  public static deleteChainLoyaltyVoucher = (chainId: string, voucherId: string) => `loyalty/chain-vouchers/${chainId}/${voucherId}`;

  // OAuth2 Developer Clients
  public static OAUTH_SCOPES: string = 'oauth/scopes';
  public static OAUTH_CLIENTS: string = 'oauth/clients';
  public static OAUTH_CLIENT_BY_ID = (clientId: string) => `oauth/clients/${clientId}`;
  public static OAUTH_ROTATE_SECRET = (clientId: string) => `oauth/clients/${clientId}/rotate-secret`;
  public static OAUTH_REVOKE = (clientId: string) => `oauth/clients/${clientId}/revoke`;
  public static OAUTH_ACTIVATE = (clientId: string) => `oauth/clients/${clientId}/activate`;

  // OIDC SSO Applications
  public static SSO_APPLICATIONS: string = 'oidc/applications';
  public static SSO_APPLICATION_BY_ID = (clientId: string) => `oidc/applications/${clientId}`;
  public static SSO_APPLICATION_ROTATE_SECRET = (clientId: string) => `oidc/applications/${clientId}/rotate-secret`;
  public static SSO_APPLICATION_REVOKE = (clientId: string) => `oidc/applications/${clientId}/revoke`;
  public static SSO_APPLICATION_ACTIVATE = (clientId: string) => `oidc/applications/${clientId}/activate`;

  // ******************** Electronic Journal (SKAT) *************************/
  public static getJournalEntries = (storeId: string) => `journal/store/${storeId}/entries`;
  public static getJournalEntry = (storeId: string, entryId: string) => `journal/store/${storeId}/entries/${entryId}`;

  // ******************** Fiscal Reports (SKAT) *************************/
  public static getXReport = (storeId: string) => `reports/store/${storeId}/x-report`;
  public static generateZReport = (storeId: string) => `reports/store/${storeId}/z-report`;
  public static getZReports = (storeId: string) => `reports/store/${storeId}/z-reports`;
  public static getZReport = (storeId: string, reportId: string) => `reports/store/${storeId}/z-reports/${reportId}`;
  public static getSaftExport = (storeId: string) => `reports/store/${storeId}/saft`;

  // ******************** Deposit Fee Types (Global Catalog) *************************/
  public static depositFeeTypes: string = 'admin/deposit-fee-types';
  public static depositFeeTypeById = (id: string) => `admin/deposit-fee-types/${id}`;
  public static detectDepositFeeType: string = 'admin/deposit-fee-types/detect';
  public static posDepositFeeTypes = (storeId: string) => `pos/store/${storeId}/deposit-fee-types`;

  // ******************** Store KPIs & Dashboard Preferences *************************/
  public static getStoreKpis = (storeId: string) => `store/${storeId}/kpis`;
  public static getChainKpis = (chainId: string) => `chains/${chainId}/kpis`;
  public static dashboardPreferences: string = 'admin/dashboard-preferences';

  // ******************** System Version *************************/
  public static apiVersion: string = 'api/version';

  // ******************** Unmatched Barcodes *************************/
  public static getUnmatchedBarcodes = (storeId: string) => `products/store/${storeId}/unmatched-barcodes`;
  public static dismissUnmatchedBarcode = (storeId: string, id: string) => `products/store/${storeId}/unmatched-barcodes/${id}`;
  public static clearUnmatchedBarcodes = (storeId: string) => `products/store/${storeId}/unmatched-barcodes`;

  // ******************** Breece ESL Integration *************************/
  public static breeceTestConnection  = (storeId: string) => `store/${storeId}/breece/test-connection`;
  public static breeceBulkSync        = (storeId: string) => `store/${storeId}/breece/bulk-sync`;
  public static breeceSyncProduct     = (storeId: string, productId: string) => `store/${storeId}/breece/sync-product/${productId}`;
  public static breeceSyncLogs        = (storeId: string) => `store/${storeId}/breece/sync-logs`;
  public static breeceSyncLogDetail   = (storeId: string, logId: string) => `store/${storeId}/breece/sync-logs/${logId}`;
  public static breecePatchConfig     = (storeId: string) => `store/${storeId}/breece/config`;
  public static breeceManualBatchSync = (storeId: string) => `store/${storeId}/breece/manual-batch-sync`;

  // ******************** Global Product Catalog *************************/
  public static globalProducts: string = 'global-products';
  public static globalProductsImportTemplate: string = 'global-products/import/template';
  public static globalProductById = (id: string) => `global-products/${id}`;
  public static globalProductsByChain = (chainId: string) => `global-products/chain/${chainId}`;
  public static globalProductSync = (id: string) => `global-products/${id}/sync`;
  public static globalProductLinkedProducts = (id: string) => `global-products/${id}/linked-products`;
  public static linkProductToGlobal = (storeId: string, productId: string) => `products/store/${storeId}/product/${productId}/link-global`;
  public static unlinkProductFromGlobal = (storeId: string, productId: string) => `products/store/${storeId}/product/${productId}/link-global`;
  public static updateProductFieldLocks = (storeId: string, productId: string) => `products/store/${storeId}/product/${productId}/field-locks`;
  public static globalCategories: string = 'global-categories';
  public static globalCategoryById = (id: string) => `global-categories/${id}`;
  public static globalCategoriesReorder: string = 'global-categories/reorder';
  public static storeGlobalCategoryMappings = (storeId: string) => `store/${storeId}/global-category-mappings`;
  public static storeGlobalCategoryResolve = (storeId: string) => `store/${storeId}/global-category-mappings/resolve`;

  // ******************** Global Reference (DSK / Vendors) *************************/
  public static globalReferenceDskGroupsTemplate: string = 'global-reference/dsk-groups/template';
  public static globalReferenceDskGroupsImport: string = 'global-reference/dsk-groups/import';
  public static globalReferenceDskGroupsSearch: string = 'global-reference/dsk-groups/search';
  public static globalReferenceDskGroupsDistinct: string = 'global-reference/dsk-groups/distinct';
  public static globalReferenceVendorsTemplate: string = 'global-reference/vendors/template';
  public static globalReferenceVendorsImport: string = 'global-reference/vendors/import';
  public static globalReferenceVendorsSearch: string = 'global-reference/vendors/search';

  // ******************** Support Center *************************/
  public static systemUpdateList: string  = 'support/system-updates';
  public static systemUpdateById: string  = 'support/system-updates/';
  public static kbCategoryList: string    = 'support/categories';
  public static kbCategoryById: string    = 'support/categories/';
  public static supportTickets: string = 'support/tickets';
  public static supportTicketStats: string = 'support/tickets/stats';
  public static supportTicket = (id: string) => `support/tickets/${id}`;
  public static supportTicketStatus = (id: string) => `support/tickets/${id}/status`;
  public static supportTicketAssign = (id: string) => `support/tickets/${id}/assign`;
  public static supportTicketMessages = (id: string) => `support/tickets/${id}/messages`;
  public static supportArticles: string = 'support/articles';
  public static supportArticle = (id: string) => `support/articles/${id}`;
  public static supportArticleUploadImage: string = 'support/articles/upload-image';

  // Invoice imports (wholesaler invoices)
  public static invoiceImportsOverview = (storeId: string) =>
    `store/${storeId}/invoice-imports/overview`;
  public static invoiceImportsList = (storeId: string) => `store/${storeId}/invoice-imports`;
  public static invoiceImportsUpload = (storeId: string) => `store/${storeId}/invoice-imports/upload`;
  public static invoiceImportById = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}`;
  public static invoiceImportFile = (storeId: string, importId: string, fileId: string) =>
    `store/${storeId}/invoice-imports/${importId}/files/${fileId}`;
  public static invoiceImportReparse = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/reparse`;
  public static invoiceImportArchive = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/archive`;
  public static invoiceImportLine = (storeId: string, importId: string, lineId: string) =>
    `store/${storeId}/invoice-imports/${importId}/lines/${lineId}`;
  public static invoiceImportLineApprove = (storeId: string, importId: string, lineId: string) =>
    `store/${storeId}/invoice-imports/${importId}/lines/${lineId}/approve`;
  public static invoiceImportLineReject = (storeId: string, importId: string, lineId: string) =>
    `store/${storeId}/invoice-imports/${importId}/lines/${lineId}/reject`;
  public static invoiceImportLineUndoAutoApprove = (storeId: string, importId: string, lineId: string) =>
    `store/${storeId}/invoice-imports/${importId}/lines/${lineId}/undo-auto-approve`;
  public static invoiceImportLinesBulkApprove = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/lines/bulk-approve`;
  public static invoiceImportApply = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/apply`;
  public static invoiceImportDeliveryGroups = (storeId: string) =>
    `store/${storeId}/invoice-imports/delivery-groups`;
  public static invoiceImportDeliveryGroup = (storeId: string, groupKey: string) =>
    `store/${storeId}/invoice-imports/delivery-groups/${encodeURIComponent(groupKey)}`;
  public static invoiceImportDeliveryGroupBulkApprove = (storeId: string, groupKey: string) =>
    `store/${storeId}/invoice-imports/delivery-groups/${encodeURIComponent(groupKey)}/bulk-approve`;
  public static invoiceImportDeliveryGroupApply = (storeId: string, groupKey: string) =>
    `store/${storeId}/invoice-imports/delivery-groups/${encodeURIComponent(groupKey)}/apply`;
  public static invoiceImportGoodsReceipt = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/goods-receipt`;
  public static invoiceImportLineDraftProduct = (storeId: string, importId: string, lineId: string) =>
    `store/${storeId}/invoice-imports/${importId}/lines/${lineId}/draft-product`;
  public static invoiceImportDraftProducts = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/draft-products`;
  public static invoiceImportPair = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/pair`;
  public static invoiceImportUnpair = (storeId: string, importId: string) =>
    `store/${storeId}/invoice-imports/${importId}/unpair`;
  public static invoiceImportProductCostLayers = (storeId: string, productId: string) =>
    `store/${storeId}/invoice-imports/products/${productId}/cost-layers`;
  public static invoiceImportTransportStock = (storeId: string) =>
    `store/${storeId}/invoice-imports/transport-stock`;
  public static invoiceImportWholesalerEnrichmentTest = (storeId: string, supplierKey: string) =>
    `store/${storeId}/invoice-imports/wholesalers/${encodeURIComponent(supplierKey)}/enrichment/test`;
  public static invoiceImportWholesalerEnrichmentPull = (storeId: string, supplierKey: string) =>
    `store/${storeId}/invoice-imports/wholesalers/${encodeURIComponent(supplierKey)}/enrichment/pull`;
  public static invoiceImportWholesalerEnrichmentStatus = (storeId: string, supplierKey: string) =>
    `store/${storeId}/invoice-imports/wholesalers/${encodeURIComponent(supplierKey)}/enrichment/status`;
  public static invoiceImportsWholesalers = (storeId: string) =>
    `store/${storeId}/invoice-imports/wholesalers`;
  public static invoiceImportsWholesalerByKey = (storeId: string, supplierKey: string) =>
    `store/${storeId}/invoice-imports/wholesalers/${encodeURIComponent(supplierKey)}`;
  public static invoiceImportSubstitutions = (storeId: string) =>
    `store/${storeId}/invoice-imports/substitutions`;
  public static invoiceImportSubstitutionById = (storeId: string, substitutionId: string) =>
    `store/${storeId}/invoice-imports/substitutions/${substitutionId}`;
  public static invoiceImportsUnassigned = 'invoice-imports/unassigned';
  public static invoiceImportAssignStore = (importId: string) =>
    `invoice-imports/${importId}/assign-store`;
  public static wholesalerDefinitionsPublic = 'wholesaler-definitions';
  public static adminWholesalerDefinitions = 'admin/wholesaler-definitions';
  public static adminWholesalerDefinitionByKey = (supplierKey: string) =>
    `admin/wholesaler-definitions/${encodeURIComponent(supplierKey)}`;
}
